/* Nastro Klarna.
   1. apre e chiude il pannello;
   2. tiene le rate allineate a quello che il cliente sta davvero comprando.

   Gli importi NON stanno qui dentro: il bundle pubblica il totale in centesimi
   (evento `md:bundle`, campo `tuo`) e questo file si limita a dividerlo per 4
   e per 3. Il simbolo di valuta arriva da Liquid, cosi su un mercato in
   sterline non si stampa un euro. */
(function () {
  'use strict';

  function avvia() {
    var radice = document.querySelector('[data-md-klarna]');
    if (!radice) return;

    var bottone  = radice.querySelector('[data-md-klarna-toggle]');
    var pannello = radice.querySelector('[data-md-klarna-pannello]');
    var simbolo  = radice.getAttribute('data-md-klarna-simbolo') || '';

    /* --- apertura --- */
    if (bottone && pannello) {
      bottone.addEventListener('click', function () {
        var aperto = bottone.getAttribute('aria-expanded') === 'true';
        bottone.setAttribute('aria-expanded', aperto ? 'false' : 'true');
        pannello.hidden = aperto;
      });
    }

    /* --- importi --- */
    var campoRata = radice.querySelector('[data-md-klarna-rata]');
    var campoR4   = radice.querySelector('[data-md-klarna-r4]');
    var campoR3   = radice.querySelector('[data-md-klarna-r3]');
    var campoTot  = radice.querySelector('[data-md-klarna-tot]');

    /* Stessa regola del bundle: si tronca ai centesimi, non si arrotonda.
       Quattro rate da 58,09 su 232,39 non devono mai superare il totale. */
    function scrivi(centesimi) {
      var c = Math.floor(centesimi);
      return simbolo + Math.floor(c / 100) + ',' + ('0' + (c % 100)).slice(-2);
    }

    function aggiorna(totale) {
      if (!(totale > 0)) return;
      var r4 = scrivi(totale / 4);
      var r3 = scrivi(totale / 3);
      if (campoRata) campoRata.textContent = r4;
      if (campoR4) campoR4.textContent = r4 + '/mese';
      if (campoR3) campoR3.textContent = r3 + '/mese';
      if (campoTot) campoTot.textContent = scrivi(totale);
    }

    document.addEventListener('md:bundle', function (e) {
      if (e && e.detail) aggiorna(e.detail.tuo);
    });

    /* Il bundle puo' essersi gia' fatto vivo prima di noi: in quel caso il
       suo stato e' li' da leggere invece di aspettare il prossimo annuncio. */
    if (window.mdBundle) aggiorna(window.mdBundle.tuo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
